import { h, JSX } from 'preact'

import { Select, SelectProps } from '../../components/forms/select/select'

export interface EventSelectionSectionProps {
    chooseEventText: string
    production: SelectProps
    event: SelectProps
    seatSelection?: SeatSelectionProps
    seatInfo?: string
}

interface SeatSelectionProps {
    chooseSeatText: string
    row: SelectProps
    seat: SelectProps
}

export const EventSelectionSection = (props: EventSelectionSectionProps): JSX.Element => (
    <div class="checkout__section">
        <div class="event-selection__section">
            <h2 class="checkout__section-title">{props.chooseEventText}</h2>
            <div class="event-selection__fields">
                <Select {...props.production} />
                <Select {...props.event} />
            </div>
        </div>
        {props.seatSelection && <SeatSelection {...props.seatSelection} />}
        {props.seatInfo && <div className="event-selection__section">{props.seatInfo}</div>}
    </div>
)

const SeatSelection = (props: SeatSelectionProps): JSX.Element => (
    <div className="event-selection__section">
        <h2 class="checkout__section-title">{props.chooseSeatText}</h2>
        <div className="event-selection__fields">
            <Select {...props.row} />
            <Select {...props.seat} />
        </div>
    </div>
)
